import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyToClipboard, useAuthentication, useB3Config, useModalStore } from "../../../../global-account/react/index.js";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { AnimatePresence, motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { useActiveWallet, useConnectedWallets, useSetActiveWallet, useWalletImage } from "thirdweb/react";
import { UserAvatar } from "../UserAvatar/UserAvatar.js";
import { ChevronDownIcon } from "../icons/ChevronDownIcon.js";
import LinkIcon from "../icons/LinkIcon.js";
import SignOutIcon from "../icons/SignOutIcon.js";
import { WalletIcon } from "../icons/WalletIcon.js";
function centerTruncate(str, length = 4) {
  if (!str) return "";
  if (str.length <= length * 2) return str;
  return `${str.slice(0, length)}...${str.slice(-length)}`;
}
// Check icon component
const CheckIcon = ({
  className
}) => _jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: className,
  children: _jsx("path", {
    d: "M16.6668 5L7.50016 14.1667L3.3335 10",
    stroke: "#0C68E9",
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
// Wallet item component
function WalletItem(t0) {
  const $ = _c(2);
  const {
    wallet,
    isActive,
    onClick
  } = t0;
  const account = wallet.getAccount();
  const address = account?.address || "";
  const {
    data: walletImage
  } = useWalletImage(wallet.id);
  const isGlobalAccount = wallet.id.includes("ecosystem");
  const walletName = wallet.id.includes("coinbase") ? "Coinbase Wallet" : wallet.id.includes("metamask") ? "MetaMask Wallet" : wallet.id.includes("phantom") ? "Phantom Wallet" : wallet.id.includes("walletConnect") ? "WalletConnect" : isGlobalAccount ? "Smart Wallet" : "Wallet";
  let t1;
  if ($[0] !== isActive) {
    t1 = isActive && _jsx("div", {
      className: "shrink-0",
      children: _jsx(CheckIcon, {})
    });
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return _jsxs("div", {
    className: `b3-modal-wallet-item ${isActive ? "b3-modal-wallet-item-active dark:bg-b3-line bg-[#F4F4F5]" : "hover:bg-b3-line/50"} box-border flex cursor-pointer items-center gap-2 rounded-xl px-3 py-2 transition-colors`,
    onClick,
    children: [_jsx("div", {
      className: "relative size-10 shrink-0 text-clip rounded-full",
      children: isGlobalAccount ? _jsx("div", {
        className: "flex size-full items-center justify-center p-1",
        children: _jsx("img", {
          src: "https://cdn.b3.fun/b3_logo.svg",
          alt: "B3",
          className: "size-full object-contain"
        })
      }) : walletImage ? _jsx("img", {
        src: walletImage,
        alt: walletName,
        className: "size-full object-contain p-1"
      }) : _jsx("div", {
        className: "flex size-full items-center justify-center",
        children: _jsx(WalletIcon, {})
      })
    }), _jsxs("div", {
      className: "flex min-w-0 flex-1 flex-col gap-1",
      children: [_jsx("p", {
        className: "text-b3-grey font-neue-montreal-semibold truncate text-sm",
        children: walletName
      }), _jsx("p", {
        className: "text-b3-foreground-muted font-neue-montreal-medium text-sm",
        children: centerTruncate(address, 4)
      })]
    }), t1]
  });
}
function BetterAuthHeader({
  onLogout
}) {
  const contentType = useModalStore(state => state.contentType);
  const setB3ModalOpen = useModalStore(state_0 => state_0.setB3ModalOpen);
  const partnerId = contentType?.partnerId;
  const {
    logout,
    user
  } = useAuthentication(partnerId);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const displayName = user?.username || user?.email || "Account";
  const onLogoutEnhanced = async () => {
    setLogoutLoading(true);
    try {
      await logout();
      onLogout?.();
    } finally {
      setB3ModalOpen(false);
      setLogoutLoading(false);
    }
  };
  return _jsxs("div", {
    className: "bg-b3-background border-b3-line flex items-center justify-between border-b px-5 py-3",
    children: [_jsxs("div", {
      className: "flex items-center gap-2",
      children: [_jsx(UserAvatar, {
        avatarUrl: user?.avatar,
        name: displayName,
        size: 40,
        className: "shrink-0"
      }), _jsxs("div", {
        className: "flex flex-col gap-0.5",
        children: [user?.username && _jsx("p", {
          className: "text-b3-grey font-neue-montreal-semibold text-left text-sm",
          children: user.username
        }), user?.email && _jsxs("div", {
          className: "flex items-center gap-1",
          children: [_jsx("p", {
            className: "text-b3-foreground-muted font-neue-montreal-medium text-sm",
            children: user.email
          }), _jsx(CopyToClipboard, {
            text: user.email
          })]
        })]
      })]
    }), _jsxs("button", {
      className: "border-b3-line hover:bg-b3-line flex items-center justify-center gap-1.5 rounded-xl border border-solid px-3 py-2 transition-colors",
      onClick: onLogoutEnhanced,
      disabled: logoutLoading,
      children: [logoutLoading ? _jsx(Loader2, {
        className: "animate-spin",
        size: 16
      }) : _jsx(SignOutIcon, {
        size: 16,
        className: "text-b3-grey"
      }), _jsx("p", {
        className: "text-b3-grey font-neue-montreal-semibold text-sm",
        children: "Sign out"
      })]
    })]
  });
}
export function Header(t0) {
  const $ = _c(4);
  const {
    onLogout
  } = t0;
  const {
    authStrategy
  } = useB3Config();
  if (authStrategy === "better-auth") {
    let t1;
    if ($[0] !== onLogout) {
      t1 = _jsx(BetterAuthHeader, {
        onLogout
      });
      $[0] = onLogout;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== onLogout) {
    t1 = _jsx(WalletHeader, {
      onLogout
    });
    $[2] = onLogout;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function WalletHeader({
  onLogout
}) {
  const activeWallet = useActiveWallet();
  const connectedWallets = useConnectedWallets();
  const setActiveWallet = useSetActiveWallet();
  const contentType = useModalStore(state => state.contentType);
  const setB3ModalOpen = useModalStore(state_0 => state_0.setB3ModalOpen);
  const setB3ModalContentType = useModalStore(state_1 => state_1.setB3ModalContentType);
  const partnerId = contentType?.partnerId;
  const {
    logout
  } = useAuthentication(partnerId);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const account = activeWallet?.getAccount();
  const address = account?.address || "";
  const {
    data: activeWalletImage
  } = useWalletImage(activeWallet?.id);
  const isActiveGlobalAccount = activeWallet?.id.includes("ecosystem");
  const onLogoutEnhanced = async () => {
    setLogoutLoading(true);
    try {
      await logout();
      onLogout?.();
    } finally {
      setB3ModalOpen(false);
      setLogoutLoading(false);
    }
  };
  const handleWalletSwitch = wallet => {
    setActiveWallet(wallet);
    setIsExpanded(false);
  };
  const handleLinkWallet = () => {
    setB3ModalContentType({
      type: "linkNewAccount",
      partnerId,
      chain: contentType?.chain,
      onSuccess: async () => {
        // Success handled by LinkAccount component
      }
    });
  };
  return _jsx(AccordionPrimitive.Root, {
    type: "single",
    collapsible: true,
    value: isExpanded ? "wallet-switcher" : "",
    className: "b3-modal-wallet-switcher bg-b3-background border-b3-line relative border-b",
    onValueChange: value => setIsExpanded(value === "wallet-switcher"),
    children: _jsxs(AccordionPrimitive.Item, {
      value: "wallet-switcher",
      className: "border-none",
      children: [_jsxs(AccordionPrimitive.Trigger, {
        className: "b3-modal-wallet-switcher-trigger group flex w-full items-center justify-between border-none bg-transparent px-5 py-3 outline-none",
        children: [_jsxs("div", {
          className: "flex items-center gap-2",
          children: [_jsx("div", {
            className: "relative size-10 shrink-0 text-clip rounded-full",
            children: isActiveGlobalAccount ? _jsx("div", {
              className: "flex size-full items-center justify-center p-1",
              children: _jsx("img", {
                src: "https://cdn.b3.fun/b3_logo.svg",
                alt: "B3",
                className: "size-full object-contain"
              })
            }) : activeWalletImage ? _jsx("img", {
              src: activeWalletImage,
              alt: "Active Wallet",
              className: "size-full object-contain p-1"
            }) : _jsx("div", {
              className: "flex size-full items-center justify-center",
              children: _jsx(WalletIcon, {})
            })
          }), _jsxs("div", {
            className: "flex flex-col gap-0.5",
            children: [_jsx("p", {
              className: "text-b3-grey font-neue-montreal-semibold text-left text-sm",
              children: "Active Wallet"
            }), _jsxs("div", {
              className: "flex items-center gap-1",
              children: [_jsx("p", {
                className: "text-b3-foreground-muted font-neue-montreal-medium text-sm",
                children: centerTruncate(address, 4)
              }), _jsx(CopyToClipboard, {
                text: address
              })]
            })]
          })]
        }), _jsx(ChevronDownIcon, {
          className: "b3-modal-wallet-switcher-chevron text-b3-grey transition-transform duration-200 group-data-[state=open]:rotate-180"
        })]
      }), _jsx(AnimatePresence, {
        children: isExpanded && _jsx(AccordionPrimitive.Content, {
          forceMount: true,
          className: "absolute left-0 right-0 top-full z-50 overflow-visible",
          children: _jsxs(motion.div, {
            initial: {
              opacity: 0,
              y: -10
            },
            animate: {
              opacity: 1,
              y: 0
            },
            exit: {
              opacity: 0,
              y: -10
            },
            transition: {
              duration: 0.2,
              ease: "easeInOut"
            },
            className: "b3-modal-wallet-switcher-content dark:bg-b3-background flex flex-col gap-3 rounded-bl-3xl rounded-br-3xl bg-white px-2 pb-5 pt-3 shadow-[0px_32px_64px_-12px_rgba(10,13,18,0.14),0px_5px_5px_-2.5px_rgba(10,13,18,0.04)]",
            children: [_jsxs("div", {
              className: "flex flex-col gap-3",
              children: [connectedWallets.map(wallet_0 => _jsx(WalletItem, {
                wallet: wallet_0,
                isActive: activeWallet?.id === wallet_0.id,
                onClick: () => handleWalletSwitch(wallet_0)
              }, wallet_0.id)), _jsxs("div", {
                className: "b3-modal-link-another-wallet hover:bg-b3-line/50 box-border flex cursor-pointer items-center gap-2 rounded-xl px-3 py-2 transition-colors",
                onClick: handleLinkWallet,
                children: [_jsx("div", {
                  className: "bg-b3-line flex size-10 shrink-0 items-center justify-center rounded-full",
                  children: _jsx(LinkIcon, {
                    className: "text-b3-grey"
                  })
                }), _jsx("div", {
                  className: "flex flex-1 flex-col",
                  children: _jsx("p", {
                    className: "text-b3-grey font-neue-montreal-semibold text-sm",
                    children: "Link another wallet"
                  })
                })]
              })]
            }), _jsxs("button", {
              className: "b3-modal-sign-out-button border-b3-line hover:bg-b3-line bg-b3-background flex items-center justify-center gap-1.5 rounded-xl border border-solid p-2.5 transition-colors",
              onClick: onLogoutEnhanced,
              disabled: logoutLoading,
              style: {
                boxShadow: "inset 0px 0px 0px 1px rgba(10,13,18,0.18), inset 0px -2px 0px 0px rgba(10,13,18,0.05)"
              },
              children: [logoutLoading ? _jsx(Loader2, {
                className: "animate-spin",
                size: 20
              }) : _jsx(SignOutIcon, {
                size: 20,
                className: "text-b3-grey"
              }), _jsx("p", {
                className: "text-b3-grey font-neue-montreal-semibold text-base",
                children: "Sign out"
              })]
            })]
          })
        })
      })]
    })
  });
}